import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { SAMLCallback400Response } from '../models/SAMLCallback400Response';
import { SAMLCallback401Response } from '../models/SAMLCallback401Response';
import { SAMLCallback500Response } from '../models/SAMLCallback500Response';

/**
 * no description
 */
export class SamlCallbackApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Handle SAML callback.
   * @param sAMLResponse Base64-encoded SAML assertion response from the identity provider
   * @param relayState Optional return URL to redirect the user after successful authentication
   */
  public async sAMLCallback(sAMLResponse: string, relayState?: string, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'sAMLResponse' is not null or undefined
    if (sAMLResponse === null || sAMLResponse === undefined) {
      throw new RequiredError("SamlCallbackApi", "sAMLCallback", "sAMLResponse");
    }



    // Path Params
    const localVarPath = '/saml/acs';

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.POST, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")



    return requestContext;
  }

}

export class SamlCallbackApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to sAMLCallback
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async sAMLCallbackWithHttpInfo(response: ResponseContext): Promise<HttpInfo<void >> {
    if (isCodeInRange("204", response.httpStatusCode)) {
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
    }
    if (isCodeInRange("302", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect to the application home page or RelayState URL after successful authentication.", undefined, response.headers, response);
    }
    if (isCodeInRange("400", response.httpStatusCode)) {
      const body: SAMLCallback400Response = ObjectSerializer.deserialize(
        await response.body.json(),
        "SAMLCallback400Response", ""
      ) as SAMLCallback400Response;
      throw new ApiException<SAMLCallback400Response>(response.httpStatusCode, "Bad request - invalid or missing SAML response", body, response.headers, response);
    }
    if (isCodeInRange("401", response.httpStatusCode)) {
      const body: SAMLCallback401Response = ObjectSerializer.deserialize(
        await response.body.json(),
        "SAMLCallback401Response", ""
      ) as SAMLCallback401Response;
      throw new ApiException<SAMLCallback401Response>(response.httpStatusCode, "Unauthorized - SAML response validation failed", body, response.headers, response);
    }
    if (isCodeInRange("500", response.httpStatusCode)) {
      const body: SAMLCallback500Response = ObjectSerializer.deserialize(
        await response.body.json(),
        "SAMLCallback500Response", ""
      ) as SAMLCallback500Response;
      throw new ApiException<SAMLCallback500Response>(response.httpStatusCode, "Internal server error", body, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: void = await response.body.json() as void;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
